/**
 * Email validation with regex
 * @param {string} email - Email to validate
 * @returns {boolean} - True if email is valid
 */
export const validateEmail = (email) => {
  if (!email || email.length > 40) {
    return false;
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

/**
 * Password validation
 * @param {string} password - Password to validate
 * @returns {Object} - Object with validation results
 */
export const validatePassword = (password) => {
  return {
    length: password.length >= 8 && password.length <= 20,
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
  };
};

/**
 * Nickname validation with regex
 * @param {string} nickname - Nickname to validate
 * @returns {boolean} - True if nickname is valid
 */
export const validateNickname = (nickname) => {
  const nicknameRegex = /^[\S]{1,20}$/;
  return nicknameRegex.test(nickname);
};

/**
 * Phone number validation
 * @param {string} phoneNumber - Phone number to validate
 * @returns {boolean} - True if phone number is valid
 */
export const validatePhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\d{1,20}$/;
  return phoneRegex.test(phoneNumber);
}; 